import { Component, OnInit, ChangeDetectorRef, AfterViewInit, OnDestroy } from '@angular/core';
import { FormGroup, Validators, FormBuilder, ValidationErrors } from '@angular/forms';
import { RefundStatusErrorDialogComponent } from '../refund-status-error-dialog/refund-status-error-dialog.component';
import { DataService } from '../../services/utils/data.service';
import { RefundStatusService } from '../../services/rest-api/refund-status.service';
import { RefundStatusRq } from '../../models/RefundStatusRq';
import { RefundProcessStep } from 'src/app/models/RefundProcessStep';
import { RefundStatusLookup } from '../../models/RefundStatusLookup';
import { RefundStatusRs } from '../../models/RefundStatusRs';
import { Header } from '../../models/Header';
import { ActivatedRoute, Router } from '@angular/router';
import { RefundStatusStep } from '../../models/RefundStatusStep';
import { TranslatorService } from 'src/app/modules/translator/providers/translator.service';
import { InterpolationService } from 'src/app/services/utils/interpolation.service';
import { RefundStatusLookupRoute } from '../../models/RefundStatusLookupRoute';
import { DialogService } from '../../services/utils/dialog.service';
@Component({
  selector: 'app-refund-status-lookup-redirect',
  templateUrl: './refund-status-lookup-redirect.component.html',
  styleUrls: ['./refund-status-lookup-redirect.component.css']
})
export class RefundStatusLookupRedirectComponent implements OnInit, OnDestroy, AfterViewInit {

  title = 'Refund Status Lookup Redirect';
  inputForm: FormGroup;
  showForSr: string;
  submittedForm;
  errorCount;
  refundStatusRq: RefundStatusRq = new RefundStatusRq();
  refundStatusLookup: RefundStatusLookup = new RefundStatusLookup();
  refundStatusRs: RefundStatusRs;
  searchClicked = false;
  public pageData: any;

  ticketNumber: string;
  firstName: string;
  lastName: string;
  loading  = true;

  constructor(private changeRef: ChangeDetectorRef,
              private formBuilder: FormBuilder,
              private dataService: DataService,
              private refundStatusService: RefundStatusService,
              private router: Router,
              private route: ActivatedRoute,
              private dialogService: DialogService,
              private translatorService: TranslatorService,
              private interpolatorService: InterpolationService) {

        this.inputForm = this.formBuilder.group({
        ticketNumber: ['', [Validators.required, Validators.minLength(13), Validators.maxLength(13)]],
        firstName: ['', [Validators.required]],
        lastName: ['', [Validators.required]]
        });
        }

  ngOnInit() {
    this.route.queryParams
        .subscribe((params) => {
        // this.refundStatusLookup.firstName = params['firstName'];
        // this.refundStatusLookup.lastName = params['lastName'];
        // this.refundStatusLookup.ticketNumber = params['ticketNumber'];
        this.ticketNumber = params.ticketNumber;
        this.firstName = params.firstName;
        this.lastName = params.lastName;
        });
    this.getPageData();
    this.changeRef.detectChanges();
    this.submitRedirect(this.ticketNumber, this.firstName, this.lastName);
  }

  // private markFormGroupTouched(formGroup: FormGroup) {
  //   (Object as any).values(formGroup.controls).forEach(control => {
  //     control.markAsTouched();

  //     if (control.controls) {
  //       this.markFormGroupTouched(control);
  //     }
  //   });
  // }

  submitRedirect(ticketNumber, firstName, lastName) {
    this.searchClicked = true;
    this.dataService.populateTicketNumber(this.ticketNumber);
    this.populateRefundStatusRq(this.ticketNumber, this.firstName, this.lastName);
    // this.markFormGroupTouched(form);
    // this.submittedForm = JSON.stringify(form.value);
    // this.errorCount = 0;
    // Object.keys(this.inputForm.controls).forEach(key => {
    //   const controlErrors: ValidationErrors = this.inputForm.get(key).errors;
    //   if(controlErrors !== null)
    //     this.errorCount++;
    // });
    // if(this.errorCount > 0) {
    //   this.searchClicked = false;
    // } else {
    //   this.checkRefundStatus();
    // }
    this.checkRefundStatus();
  }

  // submitForm(form) {
  //   this.searchClicked = true;
  //   this.dataService.populateTicketNumber(this.inputForm.value.ticketNumber);
  //   this.populateRefundStatusRq(this.inputForm.value.ticketNumber, this.inputForm.value.firstName, this.inputForm.value.lastName);
  //   this.markFormGroupTouched(form);
  //   this.submittedForm = JSON.stringify(form.value);
  //   this.errorCount = 0;
  //   Object.keys(this.inputForm.controls).forEach(key => {
  //     const controlErrors: ValidationErrors = this.inputForm.get(key).errors;
  //     if(controlErrors !== null)
  //       this.errorCount++;
  //   });
  //   if(this.errorCount > 0) {
  //     this.searchClicked = false;
  //   } else {
  //     this.checkRefundStatus();
  //   }
  // }

  checkRefundStatus() {
    this.refundStatusService.checkRefundStatus(this.refundStatusRq).subscribe((val) => {
        console.log('POST refund status call successful, response returned ',
        val);
        this.refundStatusRs = JSON.parse(val);
        if (!this.refundStatusRs.validRequest ||
        this.refundStatusRs.refundStatus.length === 0) {
        this.inputForm.reset();
        
        this.dialogService.toggleRefundStatusErrorDialog();
        //.open(RefundStatusErrorDialogComponent, {
        //    size: 'lg', ariaCloseLabel: 'Close'
        //});

        } else {
        RefundStatusLookupRoute.accessed = true;
        this.dataService.populateRefundStatusRs(this.refundStatusRs);
        this.loading = false;
        if (this.refundStatusRs.refundStatus[0].refundStatusStep === RefundStatusStep.IN_PROGRESS) {
            this.router.navigate(['refund/status/inprogress']);
        } else if (this.refundStatusRs.refundStatus[0].refundStatusStep === RefundStatusStep.REFUNDED) {
            this.router.navigate(['refund/status/refunded']);
        } else if (this.refundStatusRs.refundStatus[0].refundStatusStep === RefundStatusStep.NOT_REFUNDED) {
            this.router.navigate(['refund/status/notrefunded']);
        } else {
            this.error();
        }
        }
    },
        response => {
        this.searchClicked = false;
        console.log('POST call for refund submit in error');
        this.error();
        },
        () => {
        this.searchClicked = false;
        console.log('The POST observable for refund submit is now completed.');
        });
  }

  error() {
    this.refundStatusService.error().subscribe((val) => {
        console.log('GET call successful, goBack endpoint returned ',
        val);
        window.location.href = 'https://' + this.refundStatusService.getHostname() + val;
    },
        response => {
        this.searchClicked = false;
        console.log('GET call for goBack endpoint in error');
        console.log('GET call for goBack endpoint in error');
        this.handleError();
        },
        () => {
        this.searchClicked = false;
        console.log('The GET observable for goBack endpoint is now completed.');
        });
  }

  handleError() {
    this.refundStatusService.error().subscribe((val) => {
        console.log('GET call successful, error endpoint returned ',
        val);
        window.location.href = 'https://' + this.refundStatusService.getHostname() + val;
    },
        response => {
        this.searchClicked = false;
        console.log('GET call for error endpoint in error');
        },
        () => {
        this.searchClicked = false;
        console.log('The GET observable for error endpoint is now completed.');
        });
  }

  populateRefundStatusRq(ticketNumber: string, firstName: string, lastName: string) {
    // localStorage.clear();
    localStorage.setItem('ticketNumber', ticketNumber);
    localStorage.setItem('firstName', firstName);
    localStorage.setItem('lastName', lastName);
    this.initRefundStatusRqHeader();
    this.refundStatusLookup.ticketNumber = ticketNumber;
    this.refundStatusLookup.firstName = firstName;
    this.refundStatusLookup.lastName = lastName;
    this.refundStatusRq.refundLookupStatus = new Array<RefundStatusLookup>();
    this.refundStatusRq.refundLookupStatus.push(this.refundStatusLookup);
    localStorage.setItem('refundStatusRq', JSON.stringify(this.refundStatusRq));
  }

  initRefundStatusRqHeader() {
    this.refundStatusRq.header = new Header();
    this.refundStatusRq.header.code = 0;
    this.refundStatusRq.header.message = '';
    this.refundStatusRq.header.channel = 'AACOM';
    this.refundStatusRq.header.transactionID = '';
    this.refundStatusRq.header.refundProcessStep = RefundProcessStep.CHECK_REFUND_STATUS;
  }

  private getPageData() {
    const dataSet = new Map();
    this.pageData = this.interpolatorService
                        .interpolate(this.translatorService
                                    .getTranslations('refund-status'),
                                    dataSet);
  }

  ngAfterViewInit() {
    this.router.navigated = false;
    // alert("ngAfterViewInit in Lookup");
  }

  ngOnDestroy() {
    this.router.navigated = false;
    // alert("ngOnDestroy in Lookup");
  }

}
